export default "__VITE_ASSET__DBg8tH6c__"